/*
 * Copyright (C) 2019-2022 Corvalent Corporation - All Rights Reserved
 * This software is licensed program property and is Proprietary and Confidential.
 * Unauthorized copying of this file via any medium is strictly prohibited unless
 * prior written permission has been obtained by Corvalent Corporation.
 * In addition, the look and feel of this software as well as the user interface
 * design is also Copyright ©.
 * Notice: This software is not open source.
 * This software is subject to the Corvalent Software License Agreement.
 * You should have received a copy of this license with the software.
 * If not, please write to: sales@corvalent.com
 * All information contained herein is, and remains, the property of
 * Corvalent Corporation and its suppliers, if any. This software may also
 * be covered by U.S. and Foreign Patents, patents in progress, and are
 * protected by trade secret or copyright law
 */

import {
  FETCH_SENSOR_TYPES,
  UPDATED_SENSORS_TYPES_QUERY,
  RECEIVED_SENSOR_TYPES,
  DELETE_SENSOR_TYPES_PENDING,
  DELETE_SENSOR_TYPES_FULFILLED,
  UPDATE_SENSOR_TYPES_FULFILLED,
  UPDATE_SENSOR_TYPES_PENDING,
  ADD_SENSOR_TYPES_PENDING,
  ADD_SENSOR_TYPES_FULFILLED,
  RECEIVED_ERROR,
} from '../actions/actionTypes';

const initialState = {
  sensorTypes: [],
  sensorsTypesQueryParams: {},
  lastCreation: null,
  isPending: null,
  message: null,
  error: null,
};

export const sensorTypesReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_SENSOR_TYPES:
      return {
        ...state,
        error: null,
        message: null,
        isPending: true,
      };

    case UPDATED_SENSORS_TYPES_QUERY:
      return {
        ...state,
        sensorsTypesQueryParams: action.newValue,
      };

    case RECEIVED_SENSOR_TYPES:
      return {
        ...state,
        sensorTypes: action.newValue,
        message: null,
        isPending: false,
      };

    case ADD_SENSOR_TYPES_PENDING:
      return {
        ...state,
        isPending: true,
        lastCreation: null,
        error: null,
        message: null,
      };

    case ADD_SENSOR_TYPES_FULFILLED:
      return {
        ...state,
        sensorTypes: {
          items: (state.sensorTypes.items || []).concat([action.newValue]),
        },
        isPending: false,
        lastCreation: action.newValue,
        message: 'Sensor type created successfully!',
      };

    case UPDATE_SENSOR_TYPES_PENDING:
      return {
        ...state,
        isPending: true,
        error: null,
        message: null,
      };

    case UPDATE_SENSOR_TYPES_FULFILLED: {
      const typesList = state.sensorTypes.items || state.sensorTypes;
      return {
        ...state,
        sensorTypes: {
          items: typesList.map(assetType =>
            assetType.item_id !== action.newValue.item_id
              ? assetType
              : action.newValue,
          ),
        },
        isPending: false,
        message: 'Sensor type updated successfully!',
      };
    }

    case DELETE_SENSOR_TYPES_PENDING:
      return {
        ...state,
        isPending: true,
        error: null,
        message: null,
      };

    case DELETE_SENSOR_TYPES_FULFILLED:
      return {
        ...state,
        sensorTypes: {
          items: state.sensorTypes.items.filter(
            assetType => assetType.item_id !== action.item_id,
          ),
        },
        isPending: false,
        message: 'Sensor type deleted successfully!',
      };

    case RECEIVED_ERROR:
      return {
        ...state,
        error: action.error,
        isPending: false,
      };

    default:
      return state;
  }
};
